/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import ReviewCard from "./ReviewCard";
import Slider from "react-slick";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import { Container } from "@mui/material";
import "../index.css";
import Header from "./content-component/Header";
import { useDispatch, useSelector } from "react-redux";
import { getTestimonialWebAsync } from "src/redux/services/testimonialService";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const background = imageBaseUrl + "Testimonials.svg";

const Testimonial = ({ testimonialCard }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { testimonial, isLoading } = useSelector((state) => state.testimonial);

  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: isSmallScreen ? 1 : 2,
    slidesToScroll: 1,
    arrows: !isLargeScreen ? true : false,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const containerStyle = {
    backgroundImage: `url("${background}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    padding: { xs: "40px 0", sm: "40px 0", md: "40px 0", lg: "40px 0" },
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "20px",
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    dispatch(getTestimonialWebAsync());

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);

  return (
    <>
      <Stack sx={containerStyle}>
        <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            gap: ".5rem",
          }}
        >
          <Box
            sx={{
              marginBottom: {
                xs: "15px",
                sm: "15px",
                md: "25px",
                lg: "25px",
              },
            }}
          >
            <Header
              color="#E0F2F3"
              textAlign="center"
              content="Triumph Tales"
            />
          </Box>
        </Stack>
        {testimonial?.length > 0 ? (
          <Container
            sc={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Slider
              {...settings}
              style={{
                dipslay: "flex",
                gap: "2rem",
                marginLeft: {
                  xm: "-40px",
                  md: "250px",
                  xs: "-40px",
                  lg: "250px",
                },
                marginRight: {
                  xm: "-40px",
                  md: "-250px",
                  xs: "-40px",
                  lg: "-250px",
                },
                padding: { xm: "-40px", md: "290px", xs: "-40px", lg: "250px" },
                justifyContent: "center",
              }}
            >
              {testimonial?.map((elem, index) => (
                <Stack>
                  <ReviewCard
                    key={elem?._id}
                    id={elem?._id}
                    name={elem?.studentName}
                    icon={elem?.studentImage}
                    about={elem?.course}
                    university={elem?.university}
                    review={elem?.paragraph}
                    star={elem?.rating}
                  />
                </Stack>
              ))}
            </Slider>
          </Container>
        ) : (
          <Box sx={{ textAlign: "center", padding: "20px" }}>
            <Typography variant="h6" color="textSecondary">
              No Testimonials are available at the moment..!
            </Typography>
          </Box>
        )}
      </Stack>
    </>
  );
};

export default Testimonial;
